import React, { HTMLInputTypeAttribute } from "react";
import { RegisterOptions, useFormContext } from "react-hook-form";

interface Props {
  name: string;
  type?: HTMLInputTypeAttribute;
  placeholder?: string;
  required?: boolean;
  className?: string;
  options?: RegisterOptions;
  disabled?: boolean;
}

const TextInput: React.FC<Props> = (props): React.ReactElement => {
  const { register, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error } = getFieldState(props.name, formState);

  return (
    <div className="mb-2">
      <input
        className={`text-secondary w-full rounded-[10px] border bg-white px-4 py-3 text-base/[20px] ${props.className} autofill:bg-white ${invalid ? "border-error text-error placeholder-error" : "border-gray-accent placeholder-secondary-light hover:border-secondary focus:border-secondary focus:outline-hidden"}`}
        type={props.type}
        placeholder={props.placeholder}
        {...register(props.name, props.options)}
        disabled={props.disabled}
      />
      {error && isDirty && (
        <div className="text-error mt-1 text-[13px]">{error.message}</div>
      )}
    </div>
  );
};

export default TextInput;
